import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { AlertDialogContent } from '../../containers/table/EnhancedTable';
import AlertDialog from '../AlertDialog';

export default function SelectBypassNotificationOptOut(props: any) {
  const { bypassUserNotificationOptOut, setBypassUserNotificationOptOut, readOnly = false } = props;
  let initialValue = useRef(props.initialBypassUserNotificationOptOut);
  
  const [alertDialogContent, setAlertDialogContent] = useState<AlertDialogContent>();
  const [showAlert, setShowAlert] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue.current) {
      setBypassUserNotificationOptOut(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setBypassUserNotificationOptOut])

  return (
    <>
      <FormControlLabel
        label={(<div><Tooltip title={(<div>Uncheck for notifications which must NOT be blocked<br></br>by user preferences - such as for recalls.</div>)} arrow><div>Marketing Campaign</div></Tooltip></div>)}
        disabled={readOnly}
        control={
          <Checkbox
            checked={!bypassUserNotificationOptOut}
            indeterminate={false}
            onChange={(event) => {
              console.log('event: ', event);
              if (!event.target.checked) {
                setAlertDialogContent({
                  title: 'Confirm Change',
                  body: (<>
                    Unchecking this box will bypass customer's opt-out<br></br>
                    preference for notifications.<br></br><br></br>
                    <em>Only do this for Recall Notifications and the like</em><br></br>
                    <em>which are required by law to bypass opt-out settings.</em><br></br><br></br>
                    Are you sure you want to uncheck this setting?</>),
                  yesText: 'Yes',
                  noText: 'No',
                  yesCallback: () => setBypassUserNotificationOptOut(true),
                  noCallback: () => { }
                });
                setShowAlert(true);
              } else {
                setBypassUserNotificationOptOut(!event.target.checked)
              }
            }}
          />
        }
      />
      <AlertDialog showAlert={showAlert}
        setShowAlert={setShowAlert}
        title={alertDialogContent?.title ? alertDialogContent?.title : ''}
        body={alertDialogContent?.body ? alertDialogContent?.body : ''}
        agree={alertDialogContent?.yesText ? alertDialogContent?.yesText : ''}
        disagree={alertDialogContent?.noText ? alertDialogContent?.noText : ''}
        handleAgree={() => {
          setShowAlert(false);
          alertDialogContent?.yesCallback(true);
        }}
        handleDisagree={() => {
          setShowAlert(false);
          alertDialogContent?.noCallback(false);
        }} />
    </>
  );
}
